export default __webpack_public_path__ + "img/e5e626ce7aa7566e0548646496e7ede6.svg";